import { MonoLabel } from '@/design-system';
import { useSessionStore } from '@/shared/api';

import { DevicesCard } from './components/DevicesCard';
import { PasswordCard } from './components/PasswordCard';
import { TourCard } from './components/TourCard';
import { accountCopy } from './copy';

/**
 * Account: wat van jou is, los van het bedrijf waarin je werkt.
 *
 * Je apparaten en je wachtwoord horen bij jou als persoon - dezelfde tablet en
 * hetzelfde wachtwoord gebruik je bij elk keuringsbedrijf. Daarom is deze pagina
 * er ook zonder omgeving, en werkt alles hier met je eigen sessie, ook als een
 * platformbeheerder meekijkt.
 *
 * Bereikbaar via het gebruikersblok onderaan de rail. Hier start je ook de
 * rondleiding opnieuw.
 */
export function AccountPage() {
    const user = useSessionStore((state) => state.session?.user ?? null);

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <header className="shrink-0 bg-[var(--ink-800)] px-7 py-5">
                {user ? (
                    <div className="mb-[6px]">
                        <MonoLabel size={10} tone="onDarkMuted" as="div" className="truncate">
                            {accountCopy.eyebrow(user.name, user.email)}
                        </MonoLabel>
                    </div>
                ) : null}
                <h1 className="m-0 font-[family-name:var(--font-display)] text-[24px] leading-[1.15] font-semibold tracking-[-0.02em] text-[var(--text-on-dark)]">
                    {accountCopy.title}
                </h1>
            </header>

            <div className="flex-1 overflow-auto px-7 pt-[22px] pb-8">
                <div className="grid grid-cols-[repeat(auto-fit,minmax(340px,1fr))] items-start gap-[14px]">
                    <DevicesCard />
                    <PasswordCard />
                    <TourCard />
                </div>
            </div>
        </div>
    );
}
